export default __webpack_public_path__ + "static/media/pvilla5-3.127cf4c9.jpg";